import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {supplierRevenueShareUrl} from "~/pages/supplier-360/services/supplier360PdlUrls";
import type {RevenueShare} from "~/pages/supplier-360/types/Supplier360PdlTypes";

/** Share of the supplier's revenue — header chip and the Commercial leverage card. `null` when there's nothing to compute it from. */
export function useRevenueShareQuery(entityId: number | undefined) {
    const url = supplierRevenueShareUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<RevenueShare | null>(url)).data,
        enabled: Boolean(entityId),
    });
}
